import type { ReactNode } from 'react';

export const symbol_summarize: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M330-630q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm0 171q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm0 171q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h437q12.44 0 23.72 5T660-822l162 162q8 8 13 19.28 5 11.28 5 23.72v437q0 24-18 42t-42 18H180Zm0-60h600v-429H639q-12.75 0-21.37-8.63Q609-626.25 609-639v-141H180v600Zm0-600v171.43V-780v600-600Z"
		/>
	</svg>
);
